import { motion } from 'framer-motion';
import { X } from 'lucide-react';
import { useDemo } from '../context/DemoContext';
import { useLocation } from 'react-router-dom';

export default function DemoBanner() {
  const { isDemo, exitDemo } = useDemo();
  const { pathname } = useLocation();

  if (!isDemo || pathname.startsWith('/arcade')) return null;

  return (
    <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 1.5, type: 'spring', stiffness: 200 }}
      className="fixed bottom-6 right-6 z-[200] group" data-testid="demo-banner">

      {/* Outer pulsing rings */}
      <motion.div className="absolute inset-[-6px] rounded-full"
        style={{ border: '1px solid rgba(168,85,247,0.15)' }}
        animate={{ scale: [1, 1.3, 1], opacity: [0.4, 0, 0.4] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }} />
      <motion.div className="absolute inset-[-12px] rounded-full"
        style={{ border: '1px solid rgba(57,255,20,0.08)' }}
        animate={{ scale: [1, 1.4, 1], opacity: [0.2, 0, 0.2] }}
        transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut', delay: 0.5 }} />

      {/* Glow halo */}
      <motion.div className="absolute inset-[-4px] rounded-full"
        animate={{
          boxShadow: [
            '0 0 15px 3px rgba(168,85,247,0.2), 0 0 30px 6px rgba(57,255,20,0.05)',
            '0 0 25px 5px rgba(57,255,20,0.2), 0 0 40px 8px rgba(168,85,247,0.08)',
            '0 0 15px 3px rgba(168,85,247,0.2), 0 0 30px 6px rgba(57,255,20,0.05)',
          ]
        }}
        transition={{ duration: 3, repeat: Infinity }} />

      {/* Main orb */}
      <div className="relative w-11 h-11 rounded-full flex items-center justify-center overflow-hidden cursor-default"
        style={{ background: 'radial-gradient(circle at 40% 35%, #1a0a2e, #0a0518)', border: '1.5px solid rgba(168,85,247,0.35)' }}>

        {/* Inner shimmer */}
        <motion.div className="absolute inset-0 rounded-full"
          style={{ background: 'conic-gradient(from 0deg, transparent, rgba(168,85,247,0.1), transparent, rgba(57,255,20,0.06), transparent)' }}
          animate={{ rotate: 360 }}
          transition={{ duration: 6, repeat: Infinity, ease: 'linear' }} />

        {/* Core glow */}
        <motion.div className="absolute w-3 h-3 rounded-full"
          style={{ background: 'radial-gradient(circle, rgba(168,85,247,0.8), rgba(57,255,20,0.3), transparent)' }}
          animate={{ scale: [0.8, 1.2, 0.8], opacity: [0.5, 1, 0.5] }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }} />

        {/* Close button — appears on hover */}
        <button onClick={exitDemo} data-testid="demo-exit-btn"
          className="absolute inset-0 rounded-full flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10"
          style={{ background: 'rgba(0,0,0,0.7)' }}>
          <X className="w-3.5 h-3.5" style={{ color: 'rgba(168,85,247,0.7)' }} />
        </button>
      </div>

      {/* Label — appears on hover */}
      <motion.div className="absolute right-full mr-3 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none whitespace-nowrap px-3 py-1.5 rounded-full"
        style={{ background: 'rgba(10,5,24,0.9)', border: '1px solid rgba(168,85,247,0.2)', backdropFilter: 'blur(8px)' }}>
        <span className="text-[9px] tracking-[0.15em] uppercase font-bold"
          style={{ fontFamily: "'Cinzel', serif", color: 'rgba(168,85,247,0.6)' }}>Sewer Preview</span>
      </motion.div>
    </motion.div>
  );
}
